import { React } from "react";
import foodData from './FoodData';
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./Menu.css";


const Menu = ({ search }) => {
 

  return (
    <>

    <Link to="/Fooddetails" style={{ color: 'inherit', textDecoration: 'none' }}>
      <div className="container">
        <div className="row">
          <div className="heading-menu">
            <h2 className="title-menu pt-5 pb-5">
              {" "}
              Delivery Restaurant in Ahmedabad
            </h2>
          </div>
          {
            foodData.filter(recipe => {
              return search.toLowerCase() === "" ? recipe : recipe.title.toLowerCase().includes(search)
            }).
              map((recipe, index) => (
                <div className="container col-4 box p-0" key={index}>
                  <img src={recipe.img} alt="" />
                  <div className="dish-name mt-4 d-flex align-items-center justify-content-between">
                    <h4 className="name-0f-food d-inline">
                      {recipe.title}
                    </h4>
                    <p className="rating text-center d-inline">
                      {recipe.rating}<FontAwesomeIcon className="icon-star" icon={faStar} />
                    </p>
                  </div>
                  <div className="type-of-food w-auto mx-3 mt-2 d-flex align-items-center justify-content-between">
                    <p className="d-inline">
                      {recipe.maintitle}
                    </p>
                    <p className="d-inline">
                      ₹ {recipe.price} for 1
                    </p>
                  </div>
                  <p className="delivery-time">55min</p>
                </div>
              ))}
        </div>
      </div>
              </Link>
    </>
  );
};

export default Menu;
